<script setup lang="ts">
interface Props {
  priceId: string
  title: string
  mode?: 'payment' | 'subscription'
}

const props = defineProps<Props>()

const modelValue = defineModel<boolean>()

const { user: userInfo } = storeToRefs(useGameStateStore())
const api = useApi()

const cancelCheckout = async () => {
  try {
    // Release the purchase lock.
    await api.cancelCheckoutSession(props.priceId)
  }
  catch (error) {
    console.error('Failed to cancel checkout session', error)
  }
}

const onCancel = async () => {
  await cancelCheckout()
}

onUnmounted(async () => {
  await cancelCheckout()
})
</script>

<template>
  <DialogLargeDialog
    v-model="modelValue"
    :title="title"
    :cancel-button="{ title: 'とじる' }"
    @cancel="onCancel"
  >
    <template #default>
      <ClientOnly>
        <Payment
          :price-id="priceId"
          :require-shipping="true"
          :customer-email="userInfo?.email || ''"
          :user-id="userInfo?.userId || ''"
          :mode="mode"
        />
      </ClientOnly>
    </template>
  </DialogLargeDialog>
</template>
